<template>
  <span class="Safieicon">&#xe619;</span>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.Safieicon {
  font-size: 20px;
}
</style>
